// Generated by scripts/generate-onboarding-fallback.js from the DE/EN UI sources.
export const ONBOARDING_FALLBACK: Record<string, Record<string, string>> = {
  "de": {
    "onboarding.tree.register.terms_link_agb_sub": "Bedingungen für kostenpflichtige Angebote",
    "onboarding.tree.register.terms_link_use_terms_sub": "Regeln für die Nutzung der App",
    "common.unknown": "Unbekannt",
    "date_picker.reset": "Zurücksetzen",
    "date_picker.year": "Jahr",
    "date_picker.month": "Monat",
    "date_picker.next_month": "Nächster Monat",
    "date_picker.previous_month": "Voriger Monat",
    "date_picker.choose": "Geburtsdatum auswählen",
    "auth.native_oauth_v2_return_hint": "Bitte kehre zur Lorath-App zurück. Ohne App ist hier keine Anmeldung möglich.",
    "auth.title_login": "{brandName} — Login",
    "auth.subtitle": "Betritt die Welt der Fantasie",
    "auth.tab_login": "Anmelden",
    "auth.tab_register": "Registrieren",
    "auth.username": "Benutzername",
    "auth.identifier_label": "Benutzername oder E-Mail",
    "auth.identifier_placeholder": "Benutzername oder E-Mail",
    "auth.password": "Passwort",
    "auth.password_confirm": "Passwort bestätigen",
    "auth.email": "E-Mail-Adresse",
    "auth.email_optout": "Ich möchte keine E-Mail-Adresse angeben. Mir ist bewusst, dass wenn ich das Passwort vergesse, es keine Möglichkeit zur Accountwiederherstellung gibt. Auch der Kundendienst kann ihn dann nicht neu freischalten.",
    "auth.login_button": "Eintreten",
    "auth.register_button": "Konto erstellen",
    "auth.mode_question": "Wie möchtest du spielen?",
    "auth.mode_simple_title": "Einfach",
    "auth.mode_simple_desc": "Direkt losspielen. Erstelle Abenteuer und Charaktere — alles andere macht die KI.",
    "auth.mode_partial_title": "Teilweise",
    "auth.mode_partial_desc": "Mehr Kontrolle. Passe Erzähler:innen und Spielregeln an deine Vorlieben an.",
    "auth.mode_full_title": "Vollständig",
    "auth.mode_full_desc": "Alles verfügbar. Baue eigene Welten mit NPCs, Göttern, Völkern und mehr.",
    "auth.mode_change_hint": "Du kannst den Modus jederzeit in den Einstellungen ändern.",
    "auth.login_mode_label": "Einloggen als:",
    "auth.login_mode_default": "Meine Standardeinstellung",
    "auth.login_mode_simple": "Einfacher Modus",
    "auth.login_mode_partial": "Teilweiser Modus",
    "auth.login_mode_full": "Vollständiger Modus",
    "auth.affiliate_placeholder": "Empfehlungscode (optional)",
    "auth.google_login": "Mit Google anmelden",
    "auth.apple_login": "Mit Apple anmelden",
    "auth.apple_link": "Apple-Konto verknüpfen",
    "auth.apple_linked": "Apple-Konto verknüpft",
    "auth.apple_link_success": "Apple-Konto erfolgreich verknüpft!",
    "auth.apple_already_linked": "Dieses Apple-Konto ist bereits mit einem anderen Account verknüpft.",
    "auth.apple_error": "Apple-Verknüpfung fehlgeschlagen. Bitte erneut versuchen.",
    "auth.or_divider": "oder",
    "auth.google_failed": "Anmeldung mit Google fehlgeschlagen. Bitte versuche es erneut.",
    "auth.invited_by": "Eingeladen von {name} — {percent}% Bonus!",
    "auth.logging_in": "Anmelden…",
    "auth.beta_restricted": "Auf der Beta-Umgebung ist keine Neuregistrierung möglich. Wenn du einen Account hast, kannst du dich auf app.lorath.eu registrieren und dort einloggen.",
    "auth.oauth_link_login_first": "Zu dieser E-Mail-Adresse gibt es bereits ein Lorath-Konto. Bitte melde dich zuerst wie gewohnt an (Passwort, Google oder Apple) und verknüpfe dann Google oder Apple in den Einstellungen.",
    "auth.verify_email_error": "Die E-Mail-Bestätigung hat gerade nicht geklappt. Bitte versuche es später noch einmal.",
    "auth.verify_email_sent": "Wir haben dir einen neuen Bestätigungslink geschickt.",
    "auth.verify_email_limit": "Du hast gerade schon mehrere Bestätigungslinks angefordert. Bitte warte etwa eine Stunde.",
    "auth.guest_created": "Willkommen! Du kannst sofort loslegen.",
    "auth.guest_invalid_input": "Bitte wähle aus, wofür du hier bist und wie alt du bist.",
    "auth.guest_error": "Der Gastzugang konnte gerade nicht erstellt werden. Bitte versuche es noch einmal.",
    "auth.not_a_guest": "Dieses Konto ist bereits ein vollwertiges Konto.",
    "auth.registration_required": "Für Käufe brauchst du ein Konto. Sichere deinen Zugang mit Benutzername und Passwort oder über Google beziehungsweise Apple — dein bisheriger Fortschritt bleibt erhalten.",
    "auth.upgrade_success": "Dein Konto ist gesichert. Willkommen!",
    "auth.upgrade_error": "Das Konto konnte gerade nicht gesichert werden. Bitte versuche es noch einmal.",
    "auth.google_connected": "Google-Konto verknüpft",
    "auth.email_exists_use_google": "Diese E-Mail ist bereits mit einem Google-Konto verknüpft. Bitte melde dich mit Google an.",
    "auth.forgot_password": "Passwort vergessen?",
    "auth.remember_me": "Angemeldet bleiben",
    "auth.agb_checkbox": "Ich stimme den <a href=\"/agb.html\" data-legal-link=\"terms\">AGB</a>, der <a href=\"/datenschutz.html\" data-legal-link=\"privacy\">Datenschutzerklärung</a> und der Verwendung von Cookies zu.",
    "auth.placeholder_username": "Dein Abenteurername",
    "auth.placeholder_password": "Dein Geheimwort",
    "auth.placeholder_username_reg": "Wähle einen Namen (min. 3 Zeichen)",
    "auth.placeholder_email": "deine@email.de",
    "auth.placeholder_password_reg": "Wähle ein Passwort (min. 8 Zeichen)",
    "auth.placeholder_password_confirm": "Passwort wiederholen",
    "auth.reset_intro": "Gib deinen Benutzernamen oder deine E-Mail-Adresse ein. Wir senden dir einen Link zum Zurücksetzen.",
    "auth.reset_label": "Benutzername oder E-Mail",
    "auth.reset_placeholder": "Benutzername oder E-Mail",
    "auth.reset_button": "Link anfordern",
    "auth.reset_back": "Zurück zum Login",
    "auth.new_pw_intro": "Wähle dein neues Passwort.",
    "auth.new_pw_label": "Neues Passwort",
    "auth.new_pw_placeholder": "Min. 6 Zeichen",
    "auth.new_pw_confirm": "Passwort bestätigen",
    "auth.new_pw_button": "Passwort ändern",
    "auth.js.fields_required": "Bitte fülle alle Felder aus.",
    "auth.js.passwords_mismatch": "Passwörter stimmen nicht überein.",
    "auth.js.username_min": "Benutzername muss mindestens 3 Zeichen lang sein.",
    "auth.js.password_min": "Passwort muss mindestens 8 Zeichen lang sein.",
    "auth.js.agb_required": "Bitte stimme den AGB und der Datenschutzerklärung zu.",
    "auth.js.email_or_optout": "Bitte gib eine E-Mail-Adresse an oder bestätige den Verzicht.",
    "auth.js.creating": "Wird erstellt...",
    "auth.js.logging_in": "Anmelden...",
    "auth.js.login_failed": "Login fehlgeschlagen.",
    "auth.js.register_failed": "Registrierung fehlgeschlagen.",
    "auth.js.connection_error": "Verbindungsfehler. Bitte versuche es erneut.",
    "auth.js.reset_fill": "Bitte ausfüllen.",
    "auth.js.reset_sending": "Wird gesendet...",
    "auth.js.reset_sent": "Gesendet",
    "auth.brand_title": "{brandName}",
    "auth.change_language": "Ändern",
    "auth.trust_gdpr": "DSGVO-konform",
    "auth.trust_noemail": "Keine E-Mail-Pflicht",
    "auth.trust_free": "50 Gratis-Coins zum Start",
    "auth.trust_pay_label": "Bezahlung via:",
    "auth.creator_name": "Julius Berger, Gründer",
    "auth.creator_email": "julius.berger@lorath.eu",
    "auth.footer_creator": "Gründer",
    "auth.footer_contact": "Kontakt",
    "auth.footer_imprint": "Impressum",
    "auth.footer_privacy": "Datenschutz",
    "auth.footer_terms": "AGB",
    "auth.footer_terms_of_use": "Nutzungsbedingungen",
    "wizard.mood_label": "Stimmung",
    "wizard.mood_duester": "Düster",
    "wizard.mood_hoffnungsvoll": "Hoffnungsvoll",
    "wizard.mood_humorvoll": "Humorvoll",
    "wizard.mood_bittersuess": "Bittersüß",
    "wizard.mood_episch": "Episch",
    "wizard.mood_gemuetlich": "Gemütlich",
    "first_steps.title": "Dein Weg ins Abenteuer",
    "first_steps.subtitle": "Vier Schritte — und du bist mittendrin.",
    "first_steps.collapse": "Einklappen",
    "first_steps.tutorial_badge": "Tutorial",
    "first_steps.step_msg": "Tritt ein in dein Abenteuer",
    "first_steps.step_msg_desc": "Sprich mit der KI und beginne deine Geschichte.",
    "first_steps.step_camp": "Schreibe deine eigene Geschichte",
    "first_steps.step_camp_desc": "Erschaffe deine erste Abenteuer — die Welt gehört dir.",
    "first_steps.step_char": "Erwecke deinen Helden zum Leben",
    "first_steps.step_char_desc": "Gib ihm ein Gesicht, eine Stimme, eine Bestimmung.",
    "first_steps.step_world": "Bau deine eigene Welt",
    "first_steps.step_world_desc": "Orte, Götter, Geheimnisse — alles aus deiner Feder.",
    "quickstart.setting_fantasy": "Fantasy",
    "quickstart.setting_fantasy_text": "Klassische Fantasy-Welt mit Magie, Drachen und mittelalterlichen Reichen.",
    "quickstart.setting_scifi": "Sci-Fi",
    "quickstart.setting_scifi_text": "Ferne Zukunft, Raumschiffe, fremde Spezies, Technologie und Konflikte zwischen Sternenreichen.",
    "quickstart.setting_modern": "Modern",
    "quickstart.setting_modern_text": "Heutige Welt — vielleicht mit einem Hauch von Geheimnis oder Übernatürlichem.",
    "quickstart.setting_free": "Frei wählen",
    "quickstart.tone_light": "Locker",
    "quickstart.tone_light_text": "Humorvoll, leichtfüßig — Witz und Augenzwinkern erlaubt.",
    "quickstart.tone_balanced": "Ausgewogen",
    "quickstart.tone_balanced_text": "Ausgewogen zwischen ernst und locker.",
    "quickstart.tone_dark": "Düster",
    "quickstart.tone_dark_text": "Düster, ernst, atmosphärisch.",
    "profile.language_label": "Sprache",
    "auth.marketing_checkbox": "Marketing-E-Mails erhalten (Tipps, Updates, Angebote)",
    "auth.min_one_model": "Mindestens ein Modell muss aktiv sein.",
    "common.save": "Speichern",
    "common.cancel": "Abbrechen",
    "common.delete": "Löschen",
    "common.edit": "Bearbeiten",
    "common.close": "Schließen",
    "common.download": "Herunterladen",
    "common.gallery": "Galerie",
    "common.loading": "Lädt...",
    "common.error": "Ein Fehler ist aufgetreten.",
    "common.success": "Erfolg",
    "common.coming_soon": "Kommt bald",
    "common.confirm": "Bestätigen",
    "common.add": "Hinzufügen",
    "common.back": "Zurück",
    "common.next": "Weiter",
    "common.create": "Erstellen",
    "common.connection_error": "Verbindungsfehler.",
    "common.characters": "Zeichen",
    "common.of": "von",
    "common.selected": "ausgewählt",
    "common.level": "Stufe",
    "common.none_available": "Keine verfügbar",
    "common.profile_edit": "Profil bearbeiten",
    "auth.js.pw_min_6": "Mindestens 6 Zeichen.",
    "auth.js.connection_error_short": "Verbindungsfehler.",
    "auth.js.referral_invite_bonus": "Von einem Freund eingeladen! 20% Bonus auf deinen ersten Kauf.",
    "common.info": "Info",
    "auth.login_legal_hint": "Durch den Log-In bestätige ich, dass ich die <a href=\"/nutzungsbedingungen.html\" target=\"_blank\" style=\"color:var(--ff-gold);\">Nutzungsbedingungen</a>, <a href=\"/datenschutz.html\" target=\"_blank\" style=\"color:var(--ff-gold);\">Datenschutzbestimmungen</a>, <a href=\"/agb.html\" target=\"_blank\" style=\"color:var(--ff-gold);\">AGB</a> und die Verwendung von Cookies in ihrer aktuellen Form gelesen habe und sie akzeptiere.",
    "auth.fields_required": "Benutzername und Passwort sind erforderlich.",
    "auth.username_locked": "Dein Benutzername ist fest und kann nicht mehr geändert werden.",
    "auth.username_min": "Benutzername muss mindestens 3 Zeichen lang sein.",
    "auth.username_max": "Benutzername darf maximal 30 Zeichen lang sein.",
    "auth.password_min": "Passwort muss mindestens 8 Zeichen lang sein.",
    "auth.password_min_6": "Passwort muss mindestens 6 Zeichen haben.",
    "auth.terms_required": "Bitte stimme den Nutzungsbedingungen und der Datenschutzerklärung zu, um fortzufahren.",
    "auth.invalid_email": "Bitte gib eine gültige E-Mail-Adresse an.",
    "auth.username_taken": "Dieser Benutzername ist bereits vergeben.",
    "auth.username_invalid": "Benutzernamen dürfen nur Buchstaben, Ziffern, Punkt, Bindestrich und Unterstrich enthalten und nicht reserviert sein.",
    "auth.register_success": "Registrierung erfolgreich!",
    "auth.register_ok": "Registrierung erfolgreich.",
    "auth.register_error": "Serverfehler bei der Registrierung.",
    "auth.login_success": "Login erfolgreich!",
    "auth.login_error": "Serverfehler beim Login.",
    "auth.unknown_error": "Ein unerwarteter Fehler ist aufgetreten.",
    "auth.invalid_credentials": "Ungültiger Benutzername oder Passwort.",
    "auth.account_disabled": "Dein Account wurde deaktiviert. Wende dich an den Administrator.",
    "auth.logout_success": "Logout erfolgreich.",
    "auth.not_authenticated": "Nicht angemeldet.",
    "auth.splash_fallback": "Lädt zu lange — zum Login",
    "auth.native_google_success": "Login erfolgreich! Du kannst jetzt zur App zurückkehren.",
    "auth.native_google_link_success": "Google-Konto verknüpft! Du kannst zur App zurückkehren.",
    "auth.native_apple_link_success": "Apple-Konto verknüpft! Du kannst zur App zurückkehren.",
    "auth.native_apple_success": "Login erfolgreich! Du kannst jetzt zur App zurückkehren.",
    "auth.native_oauth_return_hint": "Dieser Tab schließt sich gleich automatisch. Falls nicht, tippe unten:",
    "auth.native_oauth_back_btn": "Zurück zur Lorath-App →",
    "auth.session_expired_login": "Die Anmeldung hat zu lange gedauert. Bitte versuche es erneut.",
    "auth.user_not_found": "Benutzer nicht gefunden.",
    "auth.user_not_found_alt": "Nutzer nicht gefunden.",
    "auth.invalid_chat_model": "Ungültiges Chat-Modell.",
    "auth.invalid_image_model": "Ungültiges Bild-Modell.",
    "auth.theme_membership_required": "Dieses Theme erfordert ein Upgrade deiner Mitgliedschaft.",
    "auth.icon_membership_required": "Dieses App-Icon ist Teil einer Mitgliedschaft.",
    "auth.profile_updated": "Profil aktualisiert.",
    "auth.profile_error": "Fehler beim Aktualisieren.",
    "auth.pw_fields_required": "Aktuelles und neues Passwort sind erforderlich.",
    "auth.pw_new_min": "Neues Passwort muss mindestens 8 Zeichen lang sein.",
    "auth.pw_old_wrong": "Aktuelles Passwort ist falsch.",
    "auth.pw_changed": "Passwort geändert.",
    "auth.pw_error": "Fehler beim Ändern des Passworts.",
    "auth.upload_format": "Nur JPEG, PNG, WebP und GIF erlaubt.",
    "auth.upload_error": "Upload-Fehler.",
    "auth.no_file": "Keine Datei.",
    "auth.portrait_uploaded": "Profilbild hochgeladen!",
    "auth.portrait_removed": "Profilbild entfernt.",
    "auth.prompt_empty": "Prompt darf nicht leer sein.",
    "auth.image_gen_error": "Fehler bei der Bildgenerierung.",
    "auth.suggest_prompt_error": "Prompt-Vorschlag konnte nicht generiert werden.",
    "auth.rate_limit_wait": "Zu viele Versuche. Bitte warte {seconds} Sekunden.",
    "auth.reset_fields_required": "Benutzername oder E-Mail-Adresse erforderlich.",
    "auth.reset_not_found": "Benutzername oder E-Mail nicht gefunden. Bitte überprüfe auf Tippfehler.",
    "auth.reset_email_sent": "Eine E-Mail mit dem Link zum Zurücksetzen wurde versendet.",
    "auth.reset_email_error": "Fehler beim Versenden der E-Mail. Bitte versuche es später erneut.",
    "auth.reset_token_required": "Token und neues Passwort erforderlich.",
    "auth.reset_invalid_token": "Ungültiger oder abgelaufener Link.",
    "auth.reset_token_expired": "Dieser Link ist abgelaufen. Bitte fordere einen neuen an.",
    "auth.reset_pw_success": "Passwort erfolgreich geändert! Du kannst dich jetzt anmelden.",
    "auth.reset_pw_error": "Fehler beim Zurücksetzen des Passworts.",
    "auth.only_admins": "Nur Admins.",
    "auth.no_email": "Benutzer hat keine E-Mail-Adresse hinterlegt.",
    "auth.reset_link_sent": "Reset-Link an {email} gesendet.",
    "auth.reset_link_generated": "Reset-Link generiert. Gültig für 1 Stunde.",
    "auth.reset_link_error": "Fehler beim Generieren des Reset-Links.",
    "auth.session_expired": "Sitzung abgelaufen. Bitte erneut anmelden.",
    "auth.templates_updated": "Systemvorlagen aktualisiert.",
    "auth.templates_skipped": "Aktualisierung übersprungen.",
    "auth.portraits_error": "Fehler beim Laden der Portraits.",
    "auth.account_deleted": "Dein Account wurde gelöscht.",
    "auth.account_delete_error": "Fehler beim Löschen des Accounts.",
    "auth.delete_account_password_required": "Passwort zur Bestätigung erforderlich.",
    "auth.delete_account_reauth_required": "Bitte re-authentifiziere dich über Google oder Apple, bevor du den Account löschst.",
    "auth.invalid_step": "Ungültiger Schritt.",
    "auth.step_done": "Schritt bereits abgeschlossen oder nicht freigeschaltet.",
    "auth.file_too_big": "Datei zu groß (max. 10 MB).",
    "auth.no_file_uploaded": "Keine Datei hochgeladen.",
    "auth.google_already_linked": "Dein Account ist bereits mit einem Google-Konto verknüpft.",
    "auth.google_link_error": "Google-Verknüpfung fehlgeschlagen.",
    "auth.access_denied": "Zugriff verweigert.",
    "auth.not_authorized": "Nicht berechtigt.",
    "auth.not_logged_in": "Nicht eingeloggt.",
    "auth.admins_only": "Nur Admins.",
    "auth.google_oauth_not_configured": "Google OAuth nicht konfiguriert.",
    "auth.invalid_language": "Ungültige Sprache.",
    "onboarding.welcome.coin_bonus_title": "Willkommen bei {brandName}!",
    "onboarding.welcome.coin_bonus": "Dein Account ist startklar: Du hast 50 Gratis-Coins für deine ersten Abenteuer. Die meisten Erzähler kosten 1–2 Coins pro Nachricht — genug, um in Ruhe loszulegen.",
    "onboarding.welcome.coin_bonus_cta": "Abenteuer starten",
    "onboarding.choice.title": "Womit möchtest du anfangen?",
    "onboarding.choice.intro": "Du hast gerade Plus aktiviert. Such dir einen Vorteil aus, mit dem du direkt loslegen möchtest. Den Rest findest du jederzeit in den Einstellungen.",
    "onboarding.choice.writing_title": "Mehr schreiben",
    "onboarding.choice.writing_body": "Weiter im letzten Abenteuer oder Charakter-Chat — wo du zuletzt aktiv warst.",
    "onboarding.choice.listening_title": "Geschichten hören",
    "onboarding.choice.listening_body": "Erzählerstimme für dein letztes Abenteuer oder Lagerfeuer bei Ultra.",
    "onboarding.choice.design_title": "Gestalten",
    "onboarding.choice.design_body": "Themes, App-Icon und Hintergründe in den Erscheinungsbild-Einstellungen.",
    "onboarding.choice.opt_in": "Erinnere mich zwei Tage vor der ersten Abbuchung",
    "onboarding.choice.skip": "Später",
    "onboarding.banner.title": "Weiter mit {benefit}",
    "onboarding.banner.text": "Du nutzt Lorath Plus seit ein paar Tagen. Entdecke als Nächstes: {benefit}. Du kannst es jederzeit ablehnen.",
    "onboarding.banner.cta": "Ausprobieren",
    "onboarding.loading": "Bereite deine Vorteile vor …",
    "onboarding.trial_reminder.title": "Deine Gratiswoche endet bald",
    "onboarding.trial_reminder.body": "Deine Gratiswoche endet am {date}. Danach wird der Preis automatisch verlängert. Du kannst jederzeit in den Store-Einstellungen kündigen.",
    "onboarding.trial_reminder.ok": "Alles klar",
    "onboarding.trial_reminder.manage": "Abo verwalten",
    "manifest.description": "KI-gestütztes Pen & Paper Rollenspiel",
    "auth.apple_oauth_unavailable": "Apple OAuth nicht konfiguriert",
    "profile_age.birthdate_invalid_format": "Ungültiges Geburtsdatum-Format. Bitte als JJJJ-MM-TT eingeben.",
    "profile_age.birthdate_invalid_date": "Dieses Datum existiert nicht.",
    "profile_age.birthdate_out_of_range": "Geburtsdatum liegt außerhalb des erlaubten Bereichs.",
    "profile_age.birthdate_future": "Geburtsdatum darf nicht in der Zukunft liegen.",
    "profile_age.birthdate_already_locked": "Geburtsdatum ist bereits gesetzt. Eine Änderung ist nur durch den Kundendienst möglich.",
    "profile_age.invalid_level": "Ungültige Inhaltsstufe.",
    "profile_age.level_not_allowed": "Diese Inhaltsstufe ist für dein Alter nicht freigeschaltet.",
    "profile_age.save_failed": "Speichern fehlgeschlagen. Bitte später erneut versuchen.",
    "profile_age.reason_too_short": "Bitte gib eine ausführlichere Begründung an (mindestens 10 Zeichen).",
    "profile_age.reason_too_long": "Begründung ist zu lang (maximal 500 Zeichen).",
    "profile_age.section_title": "Altersstufe",
    "profile_age.birthdate_label": "Geburtsdatum",
    "profile_age.birthdate_hint": "Dein Geburtsdatum wird einmalig gespeichert und kann danach nur durch den Kundendienst geändert werden. Es bleibt privat und wird nur zur Berechnung deines Alters für Inhaltsfreischaltungen verwendet.",
    "profile_age.birthdate_confirm": "Ich bestätige, dass dieses Geburtsdatum korrekt ist.",
    "profile_age.birthdate_save": "Speichern",
    "profile_age.birthdate_saved": "Geburtsdatum gespeichert.",
    "profile_age.birthdate_locked_hint": "Geburtsdatum gesperrt. Änderung nur durch Kundendienst.",
    "profile_age.request_change": "Änderung beantragen",
    "profile_age.slider_title": "Inhaltsstufe",
    "profile_age.info_aria": "Info zu den Altersstufen",
    "profile_age.current_label": "Aktuell:",
    "profile_age.level_saved": "Stufe gespeichert.",
    "profile_age.level_locked": "Diese Stufe ist für dein Alter nicht freigeschaltet.",
    "profile_age.level_0": "Ab 0",
    "profile_age.level_6": "Ab 6",
    "profile_age.level_12": "Ab 12",
    "profile_age.level_16": "Ab 16",
    "profile_age.level_18": "Ab 18",
    "profile_age.level_0_long": "Ab 0 Jahren",
    "profile_age.level_6_long": "Ab 6 Jahren",
    "profile_age.level_12_long": "Ab 12 Jahren",
    "profile_age.level_16_long": "Ab 16 Jahren",
    "profile_age.level_18_long": "Ab 18 Jahren",
    "profile_age.info_title": "Was bedeuten die Altersstufen?",
    "profile_age.info_intro": "Lorath passt seine Geschichten an dein Alter an. Du wählst selbst, ab welcher Stufe du erzählen möchtest — bis zu der Stufe, die für dein Alter freigeschaltet ist.",
    "profile_age.info_age_0": "Friedliche Geschichten mit Magie, Freundschaft und Abenteuer. Keine Gewalt, keine bedrohlichen Szenen.",
    "profile_age.info_age_6": "Mutige Heldengeschichten mit kleinen Konflikten, spannenden Verfolgungen und kleinen Schurken — wie ein Märchenfilm.",
    "profile_age.info_age_12": "Klassische Fantasy-Abenteuer mit Schwertkämpfen, ersten Gefühlen und ernsteren Themen — wie ein Jugendbuch.",
    "profile_age.info_age_16": "Dunklere Geschichten mit ernster Gewalt, schwierigen Themen und moralisch komplexen Charakteren.",
    "profile_age.info_age_18": "Geschichten ohne Einschränkungen für reife Leser. Diese Stufe enthält Inhalte, die für Jüngere nicht geeignet sind.",
    "profile_age.info_outro": "Dein Alter wird aus deinem Geburtsdatum berechnet. Du kannst jederzeit auf eine niedrigere Stufe wechseln. Auf eine höhere Stufe kommst du erst, wenn dein Account das passende Alter erreicht hat.",
    "quickstart.setting_klassische_fantasy": "Klassische Fantasy",
    "quickstart.setting_space_opera": "Space Opera",
    "quickstart.setting_cyberpunk": "Cyberpunk",
    "quickstart.setting_steampunk": "Steampunk",
    "quickstart.setting_urban_fantasy": "Urban Fantasy",
    "quickstart.setting_postapokalypse": "Postapokalypse",
    "quickstart.setting_horror": "Horror",
    "quickstart.setting_piraten": "Piraten/Seefahrt",
    "quickstart.setting_historisch": "Historisch",
    "quickstart.setting_moderne": "Moderne / Slice of Life",
    "quickstart.setting_maerchenwelt": "Märchenwelt",
    "quickstart.setting_lebenssimulation": "Lebenssimulation",
    "quickstart.tone_episch": "Episch",
    "quickstart.tone_humorvoll": "Humorvoll",
    "quickstart.tone_duester": "Düster/Horror",
    "quickstart.tone_entspannt": "Entspannt",
    "quickstart.tone_mysterioes": "Mysteriös",
    "quickstart.tone_romantisch": "Romantisch",
    "quickstart.tone_melancholisch": "Melancholisch",
    "quickstart.tone_satirisch": "Satirisch",
    "quickstart.tone_actiongeladen": "Actiongeladen",
    "quickstart.tone_maerchenhaft": "Märchenhaft",
    "onboarding.page_title": "Willkommen in Lorath",
    "onboarding.header_title": "Willkommen in Lorath",
    "onboarding.header_subtitle": "Tindra begleitet dich.",
    "onboarding.skip": "Überspringen",
    "onboarding.skip_modal_title": "Willst du wirklich überspringen?",
    "onboarding.skip_modal_text": "Du landest dann auf der klassischen Anmeldung. Du kannst die Tour jederzeit später in den Einstellungen erneut starten.",
    "onboarding.skip_modal_cancel": "Weiter chatten",
    "onboarding.skip_modal_confirm": "Ja, überspringen",
    "onboarding.typing_aria": "Tindra schreibt …",
    "onboarding.input_submit": "Senden",
    "onboarding.input_required": "Bitte gib etwas ein.",
    "onboarding.tree.start.greeting1": "Hallo! Ich bin Tindra und begleite dich durch Lorath.",
    "onboarding.tree.start.greeting2": "Hast du schon ein Konto, oder sollen wir gemeinsam loslegen?",
    "onboarding.tree.start.option_login": "Ich habe schon ein Konto",
    "onboarding.tree.start.option_register": "Ich bin neu hier",
    "onboarding.tree.placeholder.login": "Den Login-Dialog richten wir in Kürze hier ein. Bis dahin geht es klassisch über die Anmeldeseite.",
    "onboarding.tree.placeholder.register": "Die Registrierung im Chat-Stil kommt im nächsten Schritt. Du kannst dich aktuell noch klassisch anmelden.",
    "onboarding.tree.placeholder.go_login": "Zur Anmeldeseite",
    "onboarding.tree.placeholder.go_register": "Zur Registrierung",
    "onboarding.tree.placeholder.back": "Zurück zum Anfang",
    "onboarding.tree.placeholder.tour_offer": "Möchtest du, dass ich dir die wichtigsten Funktionen kurz zeige?",
    "onboarding.tree.placeholder.tour_yes": "Ja, zeig sie mir",
    "onboarding.tree.placeholder.tour_no": "Nein, direkt zum Dashboard",
    "onboarding.tree.common.back_start": "Zurück zum Anfang",
    "onboarding.tree.common.back": "← Zurück",
    "onboarding.tree.login.choose_method": "Womit möchtest du dich anmelden?",
    "onboarding.tree.login.opt_identifier": "Mit Benutzername oder E-Mail",
    "onboarding.tree.login.opt_google": "Mit Google fortfahren",
    "onboarding.tree.login.opt_apple": "Mit Apple fortfahren",
    "onboarding.tree.login.ask_identifier": "Sag mir deinen Benutzernamen oder deine E-Mail.",
    "onboarding.tree.login.placeholder_identifier": "Benutzername oder E-Mail",
    "onboarding.tree.login.ask_password": "Und dein Passwort, bitte.",
    "onboarding.tree.login.placeholder_password": "Passwort",
    "onboarding.tree.login.failed": "Das hat leider nicht geklappt. Möchtest du es nochmal versuchen?",
    "onboarding.tree.login.retry": "Erneut versuchen",
    "onboarding.tree.login.forgot_password": "Passwort vergessen",
    "onboarding.tree.login.forgot_password_option": "Passwort vergessen",
    "onboarding.tree.login.forgot_intro": "Kein Problem — das schicke ich dir per E-Mail.",
    "onboarding.tree.login.forgot_ask_identifier": "Wie ist dein Benutzername oder deine E-Mail-Adresse? Damit suche ich deinen Account und schicke dir den Reset-Link.",
    "onboarding.tree.login.forgot_placeholder_identifier": "Benutzername oder E-Mail",
    "onboarding.tree.login.forgot_sent_confirmation": "Wenn ein Account dazu existiert, ist gerade eine E-Mail mit dem Reset-Link unterwegs.",
    "onboarding.tree.login.forgot_sent_hint": "Schau auch im Spam-Ordner nach. Der Link gilt eine Stunde.",
    "onboarding.tree.login.forgot_back_to_login": "Zurück zum Login",
    "onboarding.tree.login.forgot_resend": "Nochmal versuchen",
    "onboarding.tree.login.new_account": "Doch neuen Account anlegen",
    "onboarding.tree.register.ask_name": "Schön, dass du da bist. Wie soll ich dich nennen? (Vorname oder Spitzname)",
    "onboarding.tree.register.placeholder_name": "z. B. Alex",
    "onboarding.tree.register.ask_username": "Such dir einen Benutzernamen aus — damit meldest du dich später an.",
    "onboarding.tree.register.placeholder_username": "Benutzername",
    "onboarding.tree.register.hint_username": "Mindestens 3 Zeichen, nur Buchstaben, Zahlen, _ . -",
    "onboarding.tree.register.ask_password": "Jetzt brauchst du noch ein Passwort.",
    "onboarding.tree.register.placeholder_password": "Passwort",
    "onboarding.tree.register.hint_password": "Mindestens 8 Zeichen — am besten ein langer Satz, den nur du kennst.",
    "onboarding.tree.register.ask_password_confirm": "Tipp es bitte zur Sicherheit nochmal ein.",
    "onboarding.tree.register.placeholder_password_confirm": "Passwort wiederholen",
    "onboarding.tree.register.ask_email_offer": "Möchtest du eine E-Mail hinterlegen? Damit kannst du dein Passwort später zurücksetzen.",
    "onboarding.tree.register.email_offer_yes": "Ja, E-Mail eingeben",
    "onboarding.tree.register.email_offer_no": "Nein, später",
    "onboarding.tree.register.email_skip_warning": "Ohne E-Mail können wir dir kein neues Passwort schicken, falls du es vergisst. Trotzdem ohne weitermachen?",
    "onboarding.tree.register.email_skip_continue": "Ja, ohne E-Mail",
    "onboarding.tree.register.email_skip_back": "Doch lieber eine E-Mail",
    "onboarding.tree.register.ask_email": "Sag mir deine E-Mail-Adresse.",
    "onboarding.tree.register.placeholder_email": "deine@email.de",
    "onboarding.tree.register.ask_birthdate": "Wann hast du Geburtstag? Daraus filtern wir die für dich freigegebenen USK-Stufen.",
    "onboarding.tree.register.hint_birthdate": "Wir speichern das Datum nur, um deine USK-Stufe zu bestimmen.",
    "onboarding.tree.register.age_intro": "Danke. Anhand deines Alters passt für dich am besten:",
    "onboarding.tree.register.age_recommendation": "USK-Stufe {level} — du kannst sie jederzeit im Profil ändern.",
    "onboarding.tree.register.age_accept": "Passt, übernehmen",
    "onboarding.tree.register.age_change": "Ich möchte eine andere Stufe",
    "onboarding.tree.register.age_pick_intro": "Welche Stufe darf es sein? Höhere Stufen könnten durch dein Alter gesperrt sein.",
    "onboarding.tree.register.age_blocked_by_birthdate": "Diese Stufe ist erst ab dem entsprechenden Alter freigegeben.",
    "onboarding.tree.register.age_verify.teen_16_17_info": "Danke dir. Inhalte ab 18 bleiben für dich gesperrt, aber du kannst dich ganz normal registrieren und Lorath mit den passenden Stufen nutzen.",
    "onboarding.tree.register.age_verify.teen_13_15_intro": "Für dein Alter brauchen wir kurz die Bestätigung, dass deine Eltern von deiner Registrierung wissen und einverstanden sind.",
    "onboarding.tree.register.age_verify.teen_13_15_checkbox_label": "Meine Eltern wissen von meiner Registrierung und sind damit einverstanden",
    "onboarding.tree.register.age_verify.teen_13_15_quick_reply": "Weiter",
    "onboarding.tree.register.age_verify.under_13_intro": "Eine Registrierung ist erst ab 13 Jahren möglich. Wenn ein Elternteil den Account beaufsichtigt, könnt ihr trotzdem fortfahren.",
    "onboarding.tree.register.age_verify.under_13_supervised_option": "Dies ist ein von Eltern beaufsichtigter Account",
    "onboarding.tree.register.age_verify.under_13_exit_option": "Beenden",
    "onboarding.tree.register.age_verify.under_13_goodbye_bubble": "Alles gut. Wir freuen uns, dich wiederzusehen, wenn du 13 bist!",
    "onboarding.tree.register.age_verify.under_13_goodbye_button": "Bis bald",
    "onboarding.tree.register.age_verify.quick_reply_continue": "Verstanden",
    "onboarding.tree.register.age_0": "Ab 0 (märchenhaft)",
    "onboarding.tree.register.age_6": "Ab 6 (kindgerecht)",
    "onboarding.tree.register.age_12": "Ab 12 (Abenteuer)",
    "onboarding.tree.register.age_16": "Ab 16 (Fantasy mit Härte)",
    "onboarding.tree.register.age_18": "Ab 18 (Erwachsene)",
    "onboarding.tree.register.ask_terms_intro": "Letzter Schritt: Wir haben einige Rechtstexte, hier kannst du sie dir durchlesen.",
    "onboarding.tree.register.ask_terms_question": "Mit der Registrierung bestätigst du, dass du sie zur Kenntnis genommen hast und akzeptierst.",
    "onboarding.tree.register.terms_link_use_terms": "Nutzungsbedingungen",
    "onboarding.tree.register.terms_link_agb": "AGB",
    "onboarding.tree.register.terms_link_privacy": "Datenschutzerklärung",
    "onboarding.tree.register.terms_link_privacy_sub": "Auch kinderfreundlich formuliert",
    "onboarding.tree.register.terms_accept": "Ich stimme allem zu — weiter geht's",
    "onboarding.tree.register.terms_decline": "Ich lehne ab",
    "onboarding.tree.register.failed": "Hm, das hat nicht geklappt: {error}",
    "onboarding.tree.register.retry": "Nochmal von vorn",
    "onboarding.tree.register.login_instead": "Stattdessen einloggen",
    "onboarding.tree.bridge.post_login_intro": "Willkommen zurück. Schön, dich wiederzusehen.",
    "onboarding.tree.bridge.continue": "Weiter",
    "onboarding.tree.bridge.tour_offer": "Willst du, dass ich dir die App kurz zeige?",
    "onboarding.tree.bridge.tour_yes": "Ja, zeig mir alles",
    "onboarding.tree.bridge.tour_no": "Nein, ich kenn das schon",
    "onboarding.tree.bridge.welcome_after_register": "Großartig, dein Account ist da. Ich zeig dir kurz den schnellsten Weg in dein erstes Abenteuer.",
    "onboarding.tree.bridge.welcome_continue": "Los geht's",
    "onboarding.tree.tour.dashboard": "Das hier ist dein Dashboard — von hier startest du Kampagnen und siehst, was los ist.",
    "onboarding.tree.tour.demo_campaign": "Ich habe für dich eine kleine Beispiel-Kampagne vorbereitet. Wollen wir kurz reinschauen?",
    "onboarding.tree.tour.coins_why": "Kurz zur Erklärung: Jede KI-Nachricht kostet uns selbst Geld bei den KI-Anbietern. Damit wir Lorath für dich am Leben halten und weiterentwickeln können, gibt es das Coin-System — du zahlst nur für das, was du wirklich nutzt, und wir decken damit unsere Kosten.",
    "onboarding.tree.tour.coins": "Coins sind die Währung für KI-Nachrichten. Du startest mit 50 Gratis-Coins, und die meisten Erzähler kosten nur 1–2 Coins pro Nachricht.",
    "onboarding.tree.tour.help": "Wenn du eine Frage hast, klick auf das Hilfe-Icon — Tindra ist im Chat immer für dich da.",
    "onboarding.tree.tour.finish": "Das war's. Du kannst die Tour jederzeit in den Einstellungen erneut starten.",
    "onboarding.tree.tour.next": "Weiter",
    "onboarding.tree.tour.open_demo": "Ja, öffne die Beispiel-Kampagne",
    "onboarding.tree.tour.skip_demo": "Vielleicht später",
    "onboarding.tree.tour.go_dashboard": "Jetzt zum Dashboard",
    "onboarding.validation.required": "Bitte gib etwas ein.",
    "onboarding.validation.min_length": "Bitte gib mindestens 2 Zeichen ein.",
    "onboarding.validation.username_short": "Mindestens 3 Zeichen, bitte.",
    "onboarding.validation.username_chars": "Nur Buchstaben, Zahlen, _ . - sind erlaubt.",
    "onboarding.validation.password_short": "Mindestens 8 Zeichen, bitte.",
    "onboarding.validation.password_mismatch": "Die beiden Passwörter sind nicht identisch.",
    "onboarding.validation.email_invalid": "Das sieht noch nicht nach einer gültigen E-Mail aus.",
    "onboarding.validation.birthdate_invalid": "Bitte gib ein gültiges Datum an.",
    "onboarding.validation.birthdate_future": "Das Datum kann nicht in der Zukunft liegen.",
    "onboarding.validation.birthdate_too_old": "Bitte gib ein realistisches Geburtsdatum an.",
    "onboarding.validation.checkbox_required": "Bitte bestätige diese Pflichtangabe, um fortzufahren.",
    "onboarding.age.label_age_0": "Ab 0",
    "onboarding.age.label_age_6": "Ab 6",
    "onboarding.age.label_age_12": "Ab 12",
    "onboarding.age.label_age_16": "Ab 16",
    "onboarding.age.label_age_18": "Ab 18",
    "onboarding.resume.prompt": "Wir waren schon mittendrin — möchtest du dort weitermachen, wo du aufgehört hast?",
    "onboarding.resume.continue": "Ja, weitermachen",
    "onboarding.resume.restart": "Nein, von vorn anfangen",
    "onboarding.live_check.checking": "Prüfe Verfügbarkeit …",
    "onboarding.live_check.register_username_free": "Dieser Name ist noch frei.",
    "onboarding.live_check.register_username_taken": "Dieser Name ist leider schon vergeben.",
    "onboarding.live_check.register_username_reserved": "Dieser Name ist reserviert. Bitte wähle einen anderen.",
    "onboarding.live_check.register_username_invalid": "Mindestens 3 Zeichen, nur Buchstaben, Zahlen, _ . -",
    "onboarding.live_check.register_email_free": "Diese E-Mail ist noch frei.",
    "onboarding.live_check.register_email_taken": "Mit dieser E-Mail gibt es schon ein Konto.",
    "onboarding.live_check.register_email_invalid": "Das sieht noch nicht nach einer gültigen E-Mail aus.",
    "onboarding.live_check.unavailable": "Diese Angabe ist gerade nicht möglich.",
    "onboarding.register.error_generic": "Da ist etwas schiefgegangen. Probier es bitte nochmal.",
    "onboarding.register.error_network": "Der Server ist gerade nicht erreichbar. Hast du Internet?",
    "auth.invalid_birthdate": "Bitte gib ein gültiges Geburtsdatum an.",
    "auth.invalid_age_level": "Diese USK-Stufe gibt es nicht.",
    "auth.age_level_exceeds_max": "Diese USK-Stufe ist für dein angegebenes Alter nicht freigegeben.",
    "auth.under_13_not_allowed": "Eine Registrierung ist erst ab 13 Jahren möglich.",
    "auth.parental_consent_required": "Für diese Registrierung ist die Zustimmung deiner Eltern erforderlich.",
    "auth.birthdate_required": "Bitte gib dein Geburtsdatum an.",
    "auth.complete_profile_title": "Nur noch ein Schritt",
    "auth.complete_profile_intro": "Bevor es losgeht, brauchen wir dein Geburtsdatum. Damit schalten wir die für dich passenden Inhalte frei — es bleibt privat.",
    "auth.complete_profile_submit": "Bestätigen und fortfahren",
    "auth.complete_profile_under13": "Eine eigenständige Anmeldung ist erst ab 13 Jahren möglich. Bitte wende dich an den Kundendienst.",
    "auth.parental_consent_checkbox": "Meine Eltern sind mit meiner Nutzung von Lorath einverstanden.",
    "onboarding.tutorial_unavailable": "Die Beispiel-Kampagne steht gerade nicht zur Verfügung.",
    "onboarding.tutorial_failed": "Die Beispiel-Kampagne konnte nicht geladen werden.",
    "onboarding.coin_status_failed": "Der Coin-Hinweis konnte gerade nicht geladen werden.",
    "onboarding.tour.next": "Weiter",
    "onboarding.tour.exit": "Tour beenden",
    "onboarding.tour.finish_btn": "Fertig",
    "onboarding.tour.go_to_demo": "Ins Beispiel-Abenteuer",
    "onboarding.tour.close_aria": "Tour schließen",
    "onboarding.tour.skip_demo": "Beispiel überspringen",
    "onboarding.tour.dashboard.intro_title": "Willkommen auf dem Dashboard",
    "onboarding.tour.dashboard.intro": "Von hier aus startest du Abenteuer, Tafelrunden und deine eigene Welt. Wir zeigen dir die wichtigsten Stellen in einer Minute.",
    "onboarding.tour.dashboard.campaigns_title": "Deine Abenteuer",
    "onboarding.tour.dashboard.campaigns": "Hier landen alle Abenteuer, die du startest. Ein neues Abenteuer legst du direkt von hier oder per Schnellstart an.",
    "onboarding.tour.dashboard.coins_title": "Dein Coin-Stand",
    "onboarding.tour.dashboard.coins_balance": "Oben rechts siehst du immer, wie viele Coins du gerade hast. Jede KI-Nachricht kostet ein paar — wir zeigen dir gleich, wie das alles zusammenhängt.",
    "onboarding.tour.demo.open_title": "Lust auf eine Probefahrt?",
    "onboarding.tour.demo.open_intro": "Ich habe eine kurze Beispiel-Kampagne vorbereitet. Du kannst sie öffnen und ein paar Nachrichten ausprobieren — kostet dich nichts.",
    "onboarding.tour.demo.open_button": "Beispiel-Kampagne öffnen",
    "onboarding.tour.chat.suggestion_title": "Vorschläge der KI",
    "onboarding.tour.chat.suggestion_hint": "Wenn du gerade keine Idee hast, schlägt die KI dir am Ende ihrer Antwort meistens ein paar nächste Schritte vor. Tippe auf einen, oder schreib was Eigenes.",
    "onboarding.tour.chat.ai_response_title": "Hier liest du die KI-Antwort",
    "onboarding.tour.chat.ai_response": "Tindra erzählt dir hier die Geschichte. Lies in Ruhe — du musst nichts überspringen.",
    "onboarding.tour.chat.suggestions_title": "Vorschläge der KI",
    "onboarding.tour.chat.suggestions_hint": "Wenn du keine Idee hast, schlägt dir die KI ein paar nächste Schritte vor. Tippe einen an oder schreib was Eigenes.",
    "onboarding.tour.chat.input_title": "Hier schreibst du",
    "onboarding.tour.chat.input_hint": "Schreib einfach in deinen eigenen Worten, was dein Charakter tut oder sagt. Die KI baut das in die Geschichte ein.",
    "onboarding.tour.chat.coins_title": "Coins im Chat",
    "onboarding.tour.chat.coins_explainer": "Hier oben siehst du, wie sich dein Coin-Stand entwickelt. Schauen wir uns die Coin-Seite kurz an — dort findest du deinen Coin-Shop und alle Aufladeoptionen.",
    "onboarding.tour.chat.continue_to_coins": "Weiter zur Coin-Seite",
    "onboarding.tour.coins.packages_title": "Coin-Pakete",
    "onboarding.tour.coins.packages": "Wenn deine Coins zur Neige gehen, kaufst du hier ein Paket nach. Klein bis groß — du entscheidest, wann.",
    "onboarding.tour.coins.starter_credit_title": "Dein Startguthaben: 50 Gratis-Coins",
    "onboarding.tour.coins.starter_credit": "Du hast 50 Gratis-Coins — hier ist der Coin-Shop, falls du später mehr brauchst. Die meisten Erzähler kosten 1–2 Coins pro Nachricht.",
    "onboarding.tour.coins.cheapest_pack_title": "Dein erster Kauf",
    "onboarding.tour.coins.cheapest_pack": "Wenn dir Lorath gefällt, freuen wir uns über deinen ersten Kauf — schon das kleinste Paket reicht für ~100 Nachrichten.",
    "onboarding.tour.coins.flat_section_title": "Pauschalpreis statt einzelner Coins",
    "onboarding.tour.coins.flat_section": "Eine „Nachrichten-Flat\" ist wie ein Pauschalpreis: Du zahlst einmal und schreibst dann beliebig viele Nachrichten — täglich oder monatlich. Wenn du regelmäßig spielst, sparst du damit gegenüber dem Einzelkauf von Coins.",
    "onboarding.tour.help.tindra_title": "Tindra ist da, wenn du Fragen hast",
    "onboarding.tour.help.tindra_fab": "Der lila Knopf öffnet mich als Helpbot. Frag mich nach Regeln, Funktionen oder einer Welt — ich hab Zugriff auf deine Daten.",
    "onboarding.tour.help.feedback_title": "Feedback & Bug-Meldung",
    "onboarding.tour.help.feedback_fab": "Der -Knopf öffnet das Feedback-Modal. Du kannst Text + Screenshot schicken — landet direkt bei uns im Team.",
    "onboarding.tour.help.contact_title": "Direkter Kontakt",
    "onboarding.tour.help.contact_text": "Wenn du lieber per E-Mail schreibst — schreib uns einfach. Wir antworten persönlich, in der Regel innerhalb von 1-2 Tagen.",
    "onboarding.tour.back": "← Zurück",
    "onboarding.tour.exit_confirm_title": "Tour beenden?",
    "onboarding.tour.exit_confirm_text": "Du kannst sie jederzeit aus den Einstellungen neu starten.",
    "onboarding.tour.exit_confirm_yes": "Ja, beenden",
    "onboarding.tour.exit_confirm_no": "Weiter machen",
    "onboarding.tour.closing.title": "Jetzt bist du dran",
    "onboarding.tour.closing.text": "Schreib einfach drauf los — Tindra spinnt die Geschichte mit dir weiter. Es gibt kein Richtig oder Falsch, probier alles aus. Viel Spaß in Lorath{name_phrase}!",
    "onboarding.tour.closing.cta": "Weiter spielen",
    "common.unknown_error": "Unbekannter Fehler",
    "common.error_with_message": "Fehler: {msg}",
    "legal.agb.title": "Allgemeine Geschäftsbedingungen",
    "legal.use_terms.title": "Nutzungsbedingungen",
    "legal.privacy.title": "Datenschutzerklärung",
    "onboarding.tree.login.offline": "Ich kann den Server gerade nicht erreichen. Bist du online? Prüf kurz deine Verbindung und versuch es dann noch einmal.",
    "auth.social_opening": "Browser wird geöffnet …",
    "auth.oauth_denied": "Die Anmeldung wurde beim Anbieter abgelehnt. Bitte versuche es erneut.",
    "auth.oauth_in_progress": "Eine Anmeldung läuft bereits. Bitte schließe sie zuerst ab.",
    "auth.social_login_failed": "Login fehlgeschlagen. Bitte versuche es erneut.",
    "auth.social_login_timeout": "Login hat zu lange gedauert. Bist du online? Versuche es bitte nochmal.",
    "common.section_error": "Dieser Bereich konnte nicht geladen werden.",
    "common.reload": "Neu laden",
    "common.error_details": "Details",
    "start.try_cta": "Ausprobieren",
    "auth.unlink_not_linked": "Dieses Konto ist mit diesem Anbieter nicht verknüpft.",
    "auth.unlink_last_method": "Das ist dein einziger Anmeldeweg. Setze zuerst ein Passwort oder verknüpfe einen anderen Anbieter.",
    "auth.unlink_error": "Die Verknüpfung konnte nicht getrennt werden.",
    "onboarding.tree.start.option_create_account": "Ich möchte gleich ein Konto anlegen",
    "onboarding.tree.guest.purpose_intro": "Schön, dass du da bist! Wofür bist du hier?",
    "onboarding.tree.guest.purpose_companion": "Einen Begleiter kennenlernen",
    "onboarding.tree.guest.purpose_adventure": "Ein Abenteuer erleben",
    "onboarding.tree.guest.age_intro": "Damit ich dir passende Inhalte zeige: Wie alt bist du?",
    "onboarding.tree.guest.age_under12": "Ich bin unter 12",
    "onboarding.tree.guest.age_12to15": "Ich bin 12 bis 15",
    "onboarding.tree.guest.age_16plus": "Ich bin 16 oder älter",
    "onboarding.tree.guest.failed": "Das hat gerade nicht geklappt: {error}",
    "onboarding.tree.guest.retry": "Nochmal versuchen",
    "onboarding.tree.guest.register_instead": "Lieber gleich ein Konto anlegen",
    "onboarding.tree.guest.error_rate_limited": "Gerade sind zu viele Anläufe unterwegs. Bitte später noch einmal.",
    "onboarding.tree.guest.error_beta_restricted": "Auf dieser Testumgebung sind neue Zugänge gesperrt. Bitte melde dich mit einem bestehenden Konto an.",
    "auth.guest_logout.title": "Ohne Konto abmelden?",
    "auth.guest_logout.body": "Ohne Konto verlierst du deine Charaktere und Coins. Sie lassen sich danach nicht wiederherstellen.",
    "auth.guest_logout.secure_account": "Konto sichern",
    "auth.guest_logout.logout_anyway": "Trotzdem abmelden",
    "onboarding.tree.guest.terms_hint": "Mit Weiter akzeptierst du die Nutzungsbedingungen und die Datenschutzerklärung.",
    "auth.marketing_recap_checkbox": "Wöchentlichen Rückblick per E-Mail erhalten (Bestätigung per E-Mail nötig)",
    "entry.continue_apple": "Mit Apple weiterspielen",
    "entry.continue_google": "Mit Google weiterspielen",
    "entry.register_email": "Mit E-Mail registrieren",
    "entry.try_guest": "Erst mal ohne Konto ausprobieren",
    "entry.have_account": "Ich habe ein Konto",
    "entry.tap_to_start": "Tippe, es beginnt sofort",
    "entry.build_own": "Eigenes Abenteuer bauen",
    "entry.secure_title": "Konto sichern",
    "entry.secure_body": "Sichere deine Geschichte, damit du sie auf jedem Gerät wiederfindest.",
    "entry.secure_apple": "Mit Apple sichern",
    "entry.secure_google": "Mit Google sichern",
    "entry.secure_email": "Mit E-Mail sichern",
    "entry.later": "Später",
    "entry.expiry_body": "Dein Gastzugang läuft in den nächsten fünf Tagen ab. Sichere dein Konto, damit du deine Geschichte danach weiterführen kannst.",
    "entry.oauth_already_linked": "Dieses Apple- oder Google-Konto gehört bereits zu einem anderen Lorath-Konto. Die Konten werden nicht zusammengeführt. Sichere diese Geschichte mit einem anderen Zugang oder mit E-Mail.",
    "entry.secure_error": "Das Sichern hat nicht geklappt. Du kannst es erneut versuchen oder deine Geschichte mit E-Mail sichern.",
    "entry.walkthrough": "Rundgang",
    "entry.walkthrough_error": "Der Rundgang konnte nicht geöffnet werden. Bitte versuche es erneut.",
    "entry.what_do_you_do": "Was tust du?"
  },
  "en": {
    "onboarding.tree.register.terms_link_agb_sub": "Terms for paid services",
    "onboarding.tree.register.terms_link_use_terms_sub": "Rules for using the app",
    "common.unknown": "Unknown",
    "date_picker.reset": "Reset",
    "date_picker.year": "Year",
    "date_picker.month": "Month",
    "date_picker.next_month": "Next month",
    "date_picker.previous_month": "Previous month",
    "date_picker.choose": "Choose your date of birth",
    "auth.native_oauth_v2_return_hint": "Please return to the Lorath app. You cannot sign in here without the app.",
    "auth.title_login": "{brandName} — Login",
    "auth.subtitle": "Enter the world of fantasy",
    "auth.tab_login": "Log In",
    "auth.tab_register": "Sign Up",
    "auth.username": "Username",
    "auth.identifier_label": "Username or Email",
    "auth.identifier_placeholder": "Username or email",
    "auth.password": "Password",
    "auth.password_confirm": "Confirm Password",
    "auth.email": "Email Address",
    "auth.email_optout": "I prefer not to provide an email address. I understand that if I forget my password, there will be no way to recover my account. Customer support cannot reset it either.",
    "auth.login_button": "Log In",
    "auth.register_button": "Create Account",
    "auth.mode_question": "How do you want to play?",
    "auth.mode_simple_title": "Simple",
    "auth.mode_simple_desc": "Jump right in. Create adventures and characters — the AI handles the rest.",
    "auth.mode_partial_title": "Partial",
    "auth.mode_partial_desc": "More control. Customize narrators and game rules to your liking.",
    "auth.mode_full_title": "Full",
    "auth.mode_full_desc": "Everything unlocked. Build custom worlds with NPCs, gods, races and more.",
    "auth.mode_change_hint": "You can change the mode anytime in your settings.",
    "auth.login_mode_label": "Log in as:",
    "auth.login_mode_default": "My default setting",
    "auth.login_mode_simple": "Simple mode",
    "auth.login_mode_partial": "Partial mode",
    "auth.login_mode_full": "Full mode",
    "auth.affiliate_placeholder": "Referral code (optional)",
    "auth.google_login": "Sign in with Google",
    "auth.apple_login": "Sign in with Apple",
    "auth.apple_link": "Link Apple Account",
    "auth.apple_linked": "Apple account connected",
    "auth.apple_link_success": "Apple account linked successfully!",
    "auth.apple_already_linked": "This Apple account is already linked to another account.",
    "auth.apple_error": "Apple linking failed. Please try again.",
    "auth.or_divider": "or",
    "auth.google_failed": "Sign in with Google failed. Please try again.",
    "auth.invited_by": "Invited by {name} — {percent}% Bonus!",
    "auth.logging_in": "Signing in…",
    "auth.beta_restricted": "New registrations are not possible on the beta environment. If you have an account, please register on app.lorath.eu and sign in there.",
    "auth.oauth_link_login_first": "There is already a Lorath account for this email address. Please sign in the usual way first (password, Google or Apple), then link Google or Apple in the settings.",
    "auth.verify_email_error": "The email confirmation did not work just now. Please try again later.",
    "auth.verify_email_sent": "We have sent you a new confirmation link.",
    "auth.verify_email_limit": "You have already requested several confirmation links. Please wait about an hour.",
    "auth.guest_created": "Welcome! You can start right away.",
    "auth.guest_invalid_input": "Please choose what you are here for and how old you are.",
    "auth.guest_error": "The guest access could not be created right now. Please try again.",
    "auth.not_a_guest": "This account is already a full account.",
    "auth.registration_required": "You need an account to make purchases. Secure your access with a username and password, or with Google or Apple — everything you have done so far is kept.",
    "auth.upgrade_success": "Your account is secured. Welcome!",
    "auth.upgrade_error": "The account could not be secured right now. Please try again.",
    "auth.google_connected": "Google account connected",
    "auth.email_exists_use_google": "This email is already linked to a Google account. Please sign in with Google.",
    "auth.forgot_password": "Forgot Password?",
    "auth.remember_me": "Remember me",
    "auth.agb_checkbox": "I agree to the <a href=\"/agb.html\" data-legal-link=\"terms\">Terms and Conditions</a>, the <a href=\"/datenschutz.html\" data-legal-link=\"privacy\">Privacy Policy</a>, and the use of cookies.",
    "auth.placeholder_username": "Your adventurer name",
    "auth.placeholder_password": "Your secret word",
    "auth.placeholder_username_reg": "Choose a name (min. 3 characters)",
    "auth.placeholder_email": "your@email.com",
    "auth.placeholder_password_reg": "Choose a password (min. 8 characters)",
    "auth.placeholder_password_confirm": "Repeat password",
    "auth.reset_intro": "Enter your username or email address. We will send you a reset link.",
    "auth.reset_label": "Username or Email",
    "auth.reset_placeholder": "Username or email",
    "auth.reset_button": "Request Link",
    "auth.reset_back": "Back to Login",
    "auth.new_pw_intro": "Choose your new password.",
    "auth.new_pw_label": "New Password",
    "auth.new_pw_placeholder": "Min. 6 characters",
    "auth.new_pw_confirm": "Confirm Password",
    "auth.new_pw_button": "Change Password",
    "auth.js.fields_required": "Please fill in all fields.",
    "auth.js.passwords_mismatch": "Passwords do not match.",
    "auth.js.username_min": "Username must be at least 3 characters.",
    "auth.js.password_min": "Password must be at least 8 characters.",
    "auth.js.agb_required": "Please accept the Terms and Privacy Policy.",
    "auth.js.email_or_optout": "Please provide an email or confirm the opt-out.",
    "auth.js.creating": "Creating...",
    "auth.js.logging_in": "Logging in...",
    "auth.js.login_failed": "Login failed.",
    "auth.js.register_failed": "Registration failed.",
    "auth.js.connection_error": "Connection error. Please try again.",
    "auth.js.reset_fill": "Please fill in.",
    "auth.js.reset_sending": "Sending...",
    "auth.js.reset_sent": "Sent",
    "auth.brand_title": "{brandName}",
    "auth.change_language": "Change",
    "auth.trust_gdpr": "GDPR & CCPA compliant",
    "auth.trust_noemail": "No email required",
    "auth.trust_free": "50 free coins to start",
    "auth.trust_pay_label": "Pay via:",
    "auth.creator_name": "Julius Berger, Creator",
    "auth.creator_email": "julius.berger@lorath.eu",
    "auth.footer_creator": "Creator",
    "auth.footer_contact": "Contact",
    "auth.footer_imprint": "Legal Notice",
    "auth.footer_privacy": "Privacy Policy",
    "auth.footer_terms": "Terms of Service",
    "auth.footer_terms_of_use": "Terms of Use",
    "wizard.mood_label": "Mood",
    "wizard.mood_duester": "Dark",
    "wizard.mood_hoffnungsvoll": "Hopeful",
    "wizard.mood_humorvoll": "Humorous",
    "wizard.mood_bittersuess": "Bittersweet",
    "wizard.mood_episch": "Epic",
    "wizard.mood_gemuetlich": "Cozy",
    "first_steps.title": "Your path to adventure",
    "first_steps.subtitle": "Four steps — and you're right in the middle of it.",
    "first_steps.collapse": "Collapse",
    "first_steps.tutorial_badge": "Tutorial",
    "first_steps.step_msg": "Step into your adventure",
    "first_steps.step_msg_desc": "Talk to the AI and start your story.",
    "first_steps.step_camp": "Write your own story",
    "first_steps.step_camp_desc": "Create your first adventure — the world is yours.",
    "first_steps.step_char": "Bring your hero to life",
    "first_steps.step_char_desc": "Give them a face, a voice, a destiny.",
    "first_steps.step_world": "Build your own world",
    "first_steps.step_world_desc": "Places, gods, secrets — all from your own pen.",
    "quickstart.setting_fantasy": "Fantasy",
    "quickstart.setting_fantasy_text": "Classic fantasy world with magic, dragons and medieval realms.",
    "quickstart.setting_scifi": "Sci-Fi",
    "quickstart.setting_scifi_text": "Distant future, spaceships, alien species, technology and conflicts between stellar empires.",
    "quickstart.setting_modern": "Modern",
    "quickstart.setting_modern_text": "Today's world — maybe with a touch of mystery or the supernatural.",
    "quickstart.setting_free": "Choose freely",
    "quickstart.tone_light": "Light",
    "quickstart.tone_light_text": "Humorous, light-hearted — wit and a wink are welcome.",
    "quickstart.tone_balanced": "Balanced",
    "quickstart.tone_balanced_text": "Balanced between serious and light.",
    "quickstart.tone_dark": "Dark",
    "quickstart.tone_dark_text": "Dark, serious, atmospheric.",
    "profile.language_label": "Language",
    "auth.marketing_checkbox": "Receive marketing emails (tips, updates, offers)",
    "auth.min_one_model": "At least one model must be active.",
    "common.save": "Save",
    "common.cancel": "Cancel",
    "common.delete": "Delete",
    "common.edit": "Edit",
    "common.close": "Close",
    "common.download": "Download",
    "common.gallery": "Gallery",
    "common.loading": "Loading...",
    "common.error": "Error",
    "common.success": "Success",
    "common.coming_soon": "Coming soon",
    "common.confirm": "Confirm",
    "common.add": "Add",
    "common.back": "Back",
    "common.next": "Next",
    "common.create": "Create",
    "common.connection_error": "Connection error.",
    "common.characters": "Characters",
    "common.of": "of",
    "common.selected": "selected",
    "common.level": "Level",
    "common.none_available": "None available",
    "common.profile_edit": "Edit Profile",
    "auth.js.pw_min_6": "At least 6 characters.",
    "auth.js.connection_error_short": "Connection error.",
    "auth.js.referral_invite_bonus": "Invited by a friend! 20% bonus on your first purchase.",
    "common.info": "Info",
    "auth.login_legal_hint": "By logging in I confirm that I have read and accept the <a href=\"/nutzungsbedingungen.html\" target=\"_blank\" style=\"color:var(--ff-gold);\">Terms of Use</a>, <a href=\"/datenschutz.html\" target=\"_blank\" style=\"color:var(--ff-gold);\">Privacy Policy</a>, <a href=\"/agb.html\" target=\"_blank\" style=\"color:var(--ff-gold);\">Terms & Conditions</a> and the use of cookies in their current form.",
    "auth.fields_required": "Username and password are required.",
    "auth.username_locked": "Your username is permanent and can no longer be changed.",
    "auth.username_min": "Username must be at least 3 characters long.",
    "auth.username_max": "Username must be 30 characters or less.",
    "auth.password_min": "Password must be at least 8 characters long.",
    "auth.password_min_6": "Password must be at least 6 characters long.",
    "auth.terms_required": "Please accept the Terms of Service and Privacy Policy to continue.",
    "auth.invalid_email": "Please enter a valid email address.",
    "auth.username_taken": "This username is already taken.",
    "auth.username_invalid": "Usernames may only contain letters, digits, dots, hyphens and underscores, and must not be reserved.",
    "auth.register_success": "Registration successful!",
    "auth.register_ok": "Registration successful.",
    "auth.register_error": "Server error during registration.",
    "auth.login_success": "Login successful!",
    "auth.login_error": "Server error during login.",
    "auth.unknown_error": "An unexpected error occurred.",
    "auth.invalid_credentials": "Invalid username or password.",
    "auth.account_disabled": "Your account has been disabled. Please contact the administrator.",
    "auth.logout_success": "Logged out successfully.",
    "auth.not_authenticated": "Not authenticated.",
    "auth.splash_fallback": "Loading takes too long — open login",
    "auth.native_google_success": "Login successful! You can return to the app now.",
    "auth.native_google_link_success": "Google account linked! You can return to the app.",
    "auth.native_apple_link_success": "Apple account linked! You can return to the app.",
    "auth.native_apple_success": "Login successful! You can return to the app now.",
    "auth.native_oauth_return_hint": "This tab will close automatically. If not, tap below:",
    "auth.native_oauth_back_btn": "Back to the Lorath app →",
    "auth.session_expired_login": "The sign-in took too long. Please try again.",
    "auth.user_not_found": "User not found.",
    "auth.user_not_found_alt": "User not found.",
    "auth.invalid_chat_model": "Invalid chat model.",
    "auth.invalid_image_model": "Invalid image model.",
    "auth.theme_membership_required": "This theme requires a membership upgrade.",
    "auth.icon_membership_required": "This app icon is part of a membership.",
    "auth.profile_updated": "Profile updated.",
    "auth.profile_error": "Error updating profile.",
    "auth.pw_fields_required": "Current and new password are required.",
    "auth.pw_new_min": "New password must be at least 8 characters long.",
    "auth.pw_old_wrong": "Current password is incorrect.",
    "auth.pw_changed": "Password changed.",
    "auth.pw_error": "Error changing password.",
    "auth.upload_format": "Only JPEG, PNG, WebP, and GIF are allowed.",
    "auth.upload_error": "Upload error.",
    "auth.no_file": "No file.",
    "auth.portrait_uploaded": "Profile picture uploaded!",
    "auth.portrait_removed": "Profile picture removed.",
    "auth.prompt_empty": "Prompt must not be empty.",
    "auth.image_gen_error": "Error generating image.",
    "auth.suggest_prompt_error": "Could not generate prompt suggestion.",
    "auth.rate_limit_wait": "Too many attempts. Please wait {seconds} seconds.",
    "auth.reset_fields_required": "Username or email address is required.",
    "auth.reset_not_found": "Username or email not found. Please check for typos.",
    "auth.reset_email_sent": "An email with the reset link has been sent.",
    "auth.reset_email_error": "Error sending email. Please try again later.",
    "auth.reset_token_required": "Token and new password are required.",
    "auth.reset_invalid_token": "Invalid or expired link.",
    "auth.reset_token_expired": "This link has expired. Please request a new one.",
    "auth.reset_pw_success": "Password changed successfully! You can now log in.",
    "auth.reset_pw_error": "Error resetting password.",
    "auth.only_admins": "Admins only.",
    "auth.no_email": "User has no email address on file.",
    "auth.reset_link_sent": "Reset link sent to {email}.",
    "auth.reset_link_generated": "Reset link generated. Valid for 1 hour.",
    "auth.reset_link_error": "Error generating reset link.",
    "auth.session_expired": "Session expired. Please log in again.",
    "auth.templates_updated": "System templates updated.",
    "auth.templates_skipped": "Update skipped.",
    "onboarding.welcome.coin_bonus_title": "Welcome to {brandName}!",
    "onboarding.welcome.coin_bonus": "Your account is ready: you have 50 free coins for your first adventures. Most narrators cost just 1–2 coins per message, so you have room to explore.",
    "onboarding.welcome.coin_bonus_cta": "Start your adventure",
    "onboarding.choice.title": "Where would you like to start?",
    "onboarding.choice.intro": "You just activated Plus. Pick one benefit to start with right away — you can find the others in settings any time.",
    "onboarding.choice.writing_title": "Keep writing",
    "onboarding.choice.writing_body": "Jump back into your last adventure or character chat where you left off.",
    "onboarding.choice.listening_title": "Listen to stories",
    "onboarding.choice.listening_body": "The narrator voice for your last adventure, or Campfire on Ultra.",
    "onboarding.choice.design_title": "Personalise",
    "onboarding.choice.design_body": "Themes, app icon and backgrounds in the appearance settings.",
    "onboarding.choice.opt_in": "Remind me two days before the first charge",
    "onboarding.choice.skip": "Later",
    "onboarding.banner.title": "Continue with {benefit}",
    "onboarding.banner.text": "You have been on Lorath Plus for a few days. Next up: {benefit}. You can dismiss this any time.",
    "onboarding.banner.cta": "Try it",
    "onboarding.loading": "Preparing your benefits …",
    "onboarding.trial_reminder.title": "Your free week is ending soon",
    "onboarding.trial_reminder.body": "Your free week ends on {date}. After that the price renews automatically. You can cancel any time in the store settings.",
    "onboarding.trial_reminder.ok": "Got it",
    "onboarding.trial_reminder.manage": "Manage subscription",
    "manifest.description": "AI-powered pen & paper roleplaying",
    "auth.apple_oauth_unavailable": "Apple OAuth is not configured",
    "auth.portraits_error": "Error loading the portraits.",
    "auth.account_deleted": "Your account has been deleted.",
    "auth.account_delete_error": "Error deleting the account.",
    "auth.delete_account_password_required": "Password required for confirmation.",
    "auth.delete_account_reauth_required": "Please re-authenticate via Google or Apple before deleting the account.",
    "auth.invalid_step": "Invalid step.",
    "auth.step_done": "Step already completed or not enabled.",
    "auth.file_too_big": "File too large (max. 10 MB).",
    "auth.no_file_uploaded": "No file was uploaded.",
    "auth.google_already_linked": "Your account is already linked to an Google account.",
    "auth.google_link_error": "Google -Link failed.",
    "auth.access_denied": "Access denied.",
    "auth.not_authorized": "Not authorized.",
    "auth.not_logged_in": "Not logged in.",
    "auth.admins_only": "Admins only.",
    "auth.google_oauth_not_configured": "Google OAuth is not configured.",
    "auth.invalid_language": "Invalid language.",
    "profile_age.birthdate_invalid_format": "Invalid birthdate format. Please use YYYY-MM-DD.",
    "profile_age.birthdate_invalid_date": "This date does not exist.",
    "profile_age.birthdate_out_of_range": "Birthdate is outside the allowed range.",
    "profile_age.birthdate_future": "Birthdate cannot be in the future.",
    "profile_age.birthdate_already_locked": "Your birthdate is already set. Changes can only be made by customer support.",
    "profile_age.invalid_level": "Invalid content level.",
    "profile_age.level_not_allowed": "This content level is not unlocked for your age.",
    "profile_age.save_failed": "Save failed. Please try again later.",
    "profile_age.reason_too_short": "Please provide a more detailed reason (at least 10 characters).",
    "profile_age.reason_too_long": "Reason is too long (max. 500 characters).",
    "profile_age.section_title": "Age Level",
    "profile_age.birthdate_label": "Birthdate",
    "profile_age.birthdate_hint": "Your birthdate is stored once and can only be changed by customer support afterwards. It stays private and is used only to calculate your age for content unlocks.",
    "profile_age.birthdate_confirm": "I confirm that this birthdate is correct.",
    "profile_age.birthdate_save": "Save",
    "profile_age.birthdate_saved": "Birthdate saved.",
    "profile_age.birthdate_locked_hint": "Birthdate locked. Changes only via customer support.",
    "profile_age.request_change": "Request change",
    "profile_age.slider_title": "Content Level",
    "profile_age.info_aria": "About the age levels",
    "profile_age.current_label": "Current:",
    "profile_age.level_saved": "Level saved.",
    "profile_age.level_locked": "This level is not unlocked for your age.",
    "profile_age.level_0": "Ages 0+",
    "profile_age.level_6": "Ages 6+",
    "profile_age.level_12": "Ages 12+",
    "profile_age.level_16": "Ages 16+",
    "profile_age.level_18": "Ages 18+",
    "profile_age.level_0_long": "Ages 0+",
    "profile_age.level_6_long": "Ages 6+",
    "profile_age.level_12_long": "Ages 12+",
    "profile_age.level_16_long": "Ages 16+",
    "profile_age.level_18_long": "Ages 18+",
    "profile_age.info_title": "What do the age levels mean?",
    "profile_age.info_intro": "Lorath adapts its stories to your age. You choose which level to play — up to the level unlocked for your age.",
    "profile_age.info_age_0": "Peaceful stories with magic, friendship, and adventure. No violence, no threatening scenes.",
    "profile_age.info_age_6": "Brave hero stories with small conflicts, exciting chases, and minor villains — like a fairy-tale movie.",
    "profile_age.info_age_12": "Classic fantasy adventures with sword fights, first feelings, and more serious themes — like a young-adult novel.",
    "profile_age.info_age_16": "Darker stories with serious violence, difficult themes, and morally complex characters.",
    "profile_age.info_age_18": "Stories without restrictions for mature readers. This level contains content not suitable for younger players.",
    "profile_age.info_outro": "Your age is calculated from your birthdate. You can switch to a lower level at any time. Higher levels unlock automatically once your account reaches the matching age.",
    "quickstart.setting_klassische_fantasy": "Classic Fantasy",
    "quickstart.setting_space_opera": "Space Opera",
    "quickstart.setting_cyberpunk": "Cyberpunk",
    "quickstart.setting_steampunk": "Steampunk",
    "quickstart.setting_urban_fantasy": "Urban Fantasy",
    "quickstart.setting_postapokalypse": "Post-Apocalyptic",
    "quickstart.setting_horror": "Horror",
    "quickstart.setting_piraten": "Pirates / Seafaring",
    "quickstart.setting_historisch": "Historical",
    "quickstart.setting_moderne": "Modern / Slice of Life",
    "quickstart.setting_maerchenwelt": "Fairy-Tale World",
    "quickstart.setting_lebenssimulation": "Life Simulation",
    "quickstart.tone_episch": "Epic",
    "quickstart.tone_humorvoll": "Humorous",
    "quickstart.tone_duester": "Dark / Horror",
    "quickstart.tone_entspannt": "Relaxed",
    "quickstart.tone_mysterioes": "Mysterious",
    "quickstart.tone_romantisch": "Romantic",
    "quickstart.tone_melancholisch": "Melancholic",
    "quickstart.tone_satirisch": "Satirical",
    "quickstart.tone_actiongeladen": "Action-Packed",
    "quickstart.tone_maerchenhaft": "Fairy-Tale",
    "onboarding.page_title": "Welcome to Lorath",
    "onboarding.header_title": "Welcome to Lorath",
    "onboarding.header_subtitle": "Tindra is here to guide you.",
    "onboarding.skip": "Skip",
    "onboarding.skip_modal_title": "Skip the tour?",
    "onboarding.skip_modal_text": "You'll be taken to the classic login screen. You can restart the tour later from the settings any time.",
    "onboarding.skip_modal_cancel": "Keep chatting",
    "onboarding.skip_modal_confirm": "Yes, skip",
    "onboarding.typing_aria": "Tindra is typing …",
    "onboarding.input_submit": "Send",
    "onboarding.input_required": "Please enter something.",
    "onboarding.tree.start.greeting1": "Hi! I'm Tindra and I'll guide you through Lorath.",
    "onboarding.tree.start.greeting2": "Do you already have an account, or shall we get you started from scratch?",
    "onboarding.tree.start.option_login": "I already have an account",
    "onboarding.tree.start.option_register": "I'm new here",
    "onboarding.tree.placeholder.login": "The chat-style login is coming next. For now, please use the classic sign-in page.",
    "onboarding.tree.placeholder.register": "Chat-style registration is coming in the next step. You can still register on the classic page for now.",
    "onboarding.tree.placeholder.go_login": "Go to sign-in page",
    "onboarding.tree.placeholder.go_register": "Go to registration",
    "onboarding.tree.placeholder.back": "Back to the start",
    "onboarding.tree.placeholder.tour_offer": "Would you like me to walk you through the main features?",
    "onboarding.tree.placeholder.tour_yes": "Yes, show me",
    "onboarding.tree.placeholder.tour_no": "No, take me to the dashboard",
    "onboarding.tree.common.back_start": "Back to the start",
    "onboarding.tree.common.back": "← Back",
    "onboarding.tree.login.choose_method": "How would you like to sign in?",
    "onboarding.tree.login.opt_identifier": "With username or e-mail",
    "onboarding.tree.login.opt_google": "Continue with Google",
    "onboarding.tree.login.opt_apple": "Continue with Apple",
    "onboarding.tree.login.ask_identifier": "Tell me your username or e-mail.",
    "onboarding.tree.login.placeholder_identifier": "Username or e-mail",
    "onboarding.tree.login.ask_password": "And your password, please.",
    "onboarding.tree.login.placeholder_password": "Password",
    "onboarding.tree.login.failed": "That didn't work. Would you like to try again?",
    "onboarding.tree.login.retry": "Try again",
    "onboarding.tree.login.forgot_password": "Forgot password",
    "onboarding.tree.login.forgot_password_option": "Forgot password",
    "onboarding.tree.login.forgot_intro": "No problem — I'll send you a reset link by email.",
    "onboarding.tree.login.forgot_ask_identifier": "What's your username or email address? I'll look up your account and email you the reset link.",
    "onboarding.tree.login.forgot_placeholder_identifier": "Username or email",
    "onboarding.tree.login.forgot_sent_confirmation": "If an account exists, an email with the reset link is on its way.",
    "onboarding.tree.login.forgot_sent_hint": "Check your spam folder too. The link is valid for one hour.",
    "onboarding.tree.login.forgot_back_to_login": "Back to login",
    "onboarding.tree.login.forgot_resend": "Try again",
    "onboarding.tree.login.new_account": "Create a new account instead",
    "onboarding.tree.register.ask_name": "Glad to have you. What should I call you? (First name or nickname)",
    "onboarding.tree.register.placeholder_name": "e.g. Alex",
    "onboarding.tree.register.ask_username": "Pick a username — you'll use it to log in later.",
    "onboarding.tree.register.placeholder_username": "Username",
    "onboarding.tree.register.hint_username": "At least 3 characters — letters, digits, _ . - only.",
    "onboarding.tree.register.ask_password": "Now choose a password.",
    "onboarding.tree.register.placeholder_password": "Password",
    "onboarding.tree.register.hint_password": "At least 8 characters — a long sentence only you know works best.",
    "onboarding.tree.register.ask_password_confirm": "Please type it once more, just to be sure.",
    "onboarding.tree.register.placeholder_password_confirm": "Repeat password",
    "onboarding.tree.register.ask_email_offer": "Would you like to add an e-mail? You'll need it to reset your password later.",
    "onboarding.tree.register.email_offer_yes": "Yes, add e-mail",
    "onboarding.tree.register.email_offer_no": "No, later",
    "onboarding.tree.register.email_skip_warning": "Without an e-mail we can't send you a password reset if you forget it. Still continue without one?",
    "onboarding.tree.register.email_skip_continue": "Yes, no e-mail",
    "onboarding.tree.register.email_skip_back": "Add an e-mail after all",
    "onboarding.tree.register.ask_email": "Tell me your e-mail address.",
    "onboarding.tree.register.placeholder_email": "you@example.com",
    "onboarding.tree.register.ask_birthdate": "When were you born? We use it to filter which USK ratings are unlocked for you.",
    "onboarding.tree.register.hint_birthdate": "We only store it to determine your USK rating.",
    "onboarding.tree.register.age_intro": "Thanks. Based on your age, this fits best:",
    "onboarding.tree.register.age_recommendation": "USK rating {level} — you can change it any time in your profile.",
    "onboarding.tree.register.age_accept": "Sounds good, keep it",
    "onboarding.tree.register.age_change": "I want a different rating",
    "onboarding.tree.register.age_pick_intro": "Which rating would you like? Higher ratings may be locked by your age.",
    "onboarding.tree.register.age_blocked_by_birthdate": "This rating is only unlocked from the corresponding age onwards.",
    "onboarding.tree.register.age_verify.teen_16_17_info": "Thanks. Age-18 content stays locked for you, but you can register normally and use Lorath with the ratings that fit your age.",
    "onboarding.tree.register.age_verify.teen_13_15_intro": "For your age, we need a quick confirmation that your parents know about your registration and agree to it.",
    "onboarding.tree.register.age_verify.teen_13_15_checkbox_label": "My parents know about my registration and agree to it",
    "onboarding.tree.register.age_verify.teen_13_15_quick_reply": "Continue",
    "onboarding.tree.register.age_verify.under_13_intro": "Registration is only possible from age 13. If a parent is supervising this account, you can still continue.",
    "onboarding.tree.register.age_verify.under_13_supervised_option": "This is a parent-supervised account",
    "onboarding.tree.register.age_verify.under_13_exit_option": "Exit",
    "onboarding.tree.register.age_verify.under_13_goodbye_bubble": "That's okay. We'll be happy to see you again when you're 13!",
    "onboarding.tree.register.age_verify.under_13_goodbye_button": "See you soon",
    "onboarding.tree.register.age_verify.quick_reply_continue": "Got it",
    "onboarding.tree.register.age_0": "Ages 0+ (fairytale)",
    "onboarding.tree.register.age_6": "Ages 6+ (kid-friendly)",
    "onboarding.tree.register.age_12": "Ages 12+ (adventure)",
    "onboarding.tree.register.age_16": "Ages 16+ (gritty fantasy)",
    "onboarding.tree.register.age_18": "Ages 18+ (adult)",
    "onboarding.tree.register.ask_terms_intro": "Last step: we have a few legal texts — feel free to read them here.",
    "onboarding.tree.register.ask_terms_question": "By signing up you confirm that you have taken note of them and accept them.",
    "onboarding.tree.register.terms_link_use_terms": "Terms of Use",
    "onboarding.tree.register.terms_link_agb": "General Terms and Conditions",
    "onboarding.tree.register.terms_link_privacy": "Privacy Policy",
    "onboarding.tree.register.terms_link_privacy_sub": "Also written in plain language",
    "onboarding.tree.register.terms_accept": "I agree to everything — let's continue",
    "onboarding.tree.register.terms_decline": "I decline",
    "onboarding.tree.register.failed": "Hmm, that didn't work: {error}",
    "onboarding.tree.register.retry": "Start over",
    "onboarding.tree.register.login_instead": "Log in instead",
    "onboarding.tree.bridge.post_login_intro": "Welcome back. Good to see you again.",
    "onboarding.tree.bridge.continue": "Continue",
    "onboarding.tree.bridge.tour_offer": "Shall I give you a quick tour of the app?",
    "onboarding.tree.bridge.tour_yes": "Yes, show me everything",
    "onboarding.tree.bridge.tour_no": "No, I know my way around",
    "onboarding.tree.bridge.welcome_after_register": "Wonderful, your account is ready. Let me show you the quickest way into your first adventure.",
    "onboarding.tree.bridge.welcome_continue": "Let's go",
    "onboarding.tree.tour.dashboard": "This is your dashboard — you start campaigns and check what's going on from here.",
    "onboarding.tree.tour.demo_campaign": "I've prepared a small sample campaign for you. Want to take a quick look?",
    "onboarding.tree.tour.coins_why": "A little background: every AI message actually costs us money on the providers' side. The coin system is how we keep Lorath running and growing — you only pay for what you actually use, and it covers our costs.",
    "onboarding.tree.tour.coins": "Coins are the currency for AI messages. You start with 50 free coins, and most narrators cost only 1–2 coins per message.",
    "onboarding.tree.tour.help": "If you have a question, tap the help icon — Tindra is always around in the chat.",
    "onboarding.tree.tour.finish": "That's it. You can restart this tour any time in the settings.",
    "onboarding.tree.tour.next": "Next",
    "onboarding.tree.tour.open_demo": "Yes, open the sample campaign",
    "onboarding.tree.tour.skip_demo": "Maybe later",
    "onboarding.tree.tour.go_dashboard": "To the dashboard",
    "onboarding.validation.required": "Please enter something.",
    "onboarding.validation.min_length": "Please enter at least 2 characters.",
    "onboarding.validation.username_short": "At least 3 characters, please.",
    "onboarding.validation.username_chars": "Only letters, digits, _ . - are allowed.",
    "onboarding.validation.password_short": "At least 8 characters, please.",
    "onboarding.validation.password_mismatch": "The two passwords don't match.",
    "onboarding.validation.email_invalid": "That doesn't look like a valid e-mail yet.",
    "onboarding.validation.birthdate_invalid": "Please enter a valid date.",
    "onboarding.validation.birthdate_future": "The date can't be in the future.",
    "onboarding.validation.birthdate_too_old": "Please enter a realistic birthdate.",
    "onboarding.validation.checkbox_required": "Please confirm this required field to continue.",
    "onboarding.age.label_age_0": "Ages 0+",
    "onboarding.age.label_age_6": "Ages 6+",
    "onboarding.age.label_age_12": "Ages 12+",
    "onboarding.age.label_age_16": "Ages 16+",
    "onboarding.age.label_age_18": "Ages 18+",
    "onboarding.resume.prompt": "We were in the middle of something — would you like to continue where you left off?",
    "onboarding.resume.continue": "Yes, continue",
    "onboarding.resume.restart": "No, start over",
    "onboarding.live_check.checking": "Checking availability…",
    "onboarding.live_check.register_username_free": "That name is still free.",
    "onboarding.live_check.register_username_taken": "That name is already taken.",
    "onboarding.live_check.register_username_reserved": "That name is reserved. Please choose another one.",
    "onboarding.live_check.register_username_invalid": "At least 3 characters, only letters, numbers, _ . -",
    "onboarding.live_check.register_email_free": "That email is still free.",
    "onboarding.live_check.register_email_taken": "There is already an account with this email.",
    "onboarding.live_check.register_email_invalid": "That doesn't look like a valid email yet.",
    "onboarding.live_check.unavailable": "This entry is not possible right now.",
    "onboarding.register.error_generic": "Something went wrong. Please try again.",
    "onboarding.register.error_network": "The server isn't reachable right now. Do you have an internet connection?",
    "auth.invalid_birthdate": "Please enter a valid date of birth.",
    "auth.invalid_age_level": "That age rating doesn't exist.",
    "auth.age_level_exceeds_max": "That age rating is not allowed for the date of birth you provided.",
    "auth.under_13_not_allowed": "Registration is only possible from age 13.",
    "auth.parental_consent_required": "Parental consent is required for this registration.",
    "auth.birthdate_required": "Please enter your date of birth.",
    "auth.complete_profile_title": "Just one more step",
    "auth.complete_profile_intro": "Before you begin, we need your date of birth. We use it to unlock content that fits your age — it stays private.",
    "auth.complete_profile_submit": "Confirm and continue",
    "auth.complete_profile_under13": "You must be at least 13 to register on your own. Please contact customer support.",
    "auth.parental_consent_checkbox": "My parents agree to my use of Lorath.",
    "onboarding.tutorial_unavailable": "The sample campaign isn't available right now.",
    "onboarding.tutorial_failed": "We couldn't load the sample campaign.",
    "onboarding.coin_status_failed": "We couldn't load the coin info right now.",
    "onboarding.tour.next": "Next",
    "onboarding.tour.exit": "End tour",
    "onboarding.tour.finish_btn": "Done",
    "onboarding.tour.go_to_demo": "Into the example adventure",
    "onboarding.tour.close_aria": "Close tour",
    "onboarding.tour.skip_demo": "Skip the demo",
    "onboarding.tour.dashboard.intro_title": "Welcome to your dashboard",
    "onboarding.tour.dashboard.intro": "This is the place where you launch adventures, table rounds and your own world. We'll show you the key spots in about a minute.",
    "onboarding.tour.dashboard.campaigns_title": "Your adventures",
    "onboarding.tour.dashboard.campaigns": "Every adventure you start lives here. You can create a fresh adventure right from this tile or via the quickstart shortcut.",
    "onboarding.tour.dashboard.coins_title": "Your coin balance",
    "onboarding.tour.dashboard.coins_balance": "At the top right you always see how many coins you have. Every AI message costs a few — we'll explain in a moment.",
    "onboarding.tour.demo.open_title": "Want to take it for a spin?",
    "onboarding.tour.demo.open_intro": "I've prepared a short sample campaign. You can open it and try a few messages — it's on the house.",
    "onboarding.tour.demo.open_button": "Open the sample campaign",
    "onboarding.tour.chat.suggestion_title": "AI suggestions",
    "onboarding.tour.chat.suggestion_hint": "If you ever feel stuck, the AI usually offers a few next steps at the end of its reply. Tap one, or write your own.",
    "onboarding.tour.chat.ai_response_title": "Here you read the AI's reply",
    "onboarding.tour.chat.ai_response": "Tindra tells you the story here. Take your time reading — nothing to skip.",
    "onboarding.tour.chat.suggestions_title": "AI suggestions",
    "onboarding.tour.chat.suggestions_hint": "When you have no idea what to do, the AI suggests a few next steps. Tap one or write your own.",
    "onboarding.tour.chat.input_title": "Type here",
    "onboarding.tour.chat.input_hint": "Just write what your character does or says, in your own words. The AI will weave it into the story.",
    "onboarding.tour.chat.coins_title": "Coins inside the chat",
    "onboarding.tour.chat.coins_explainer": "Up here you'll see your balance update live. Let's pop over to the coin page next — that's where your coin shop and top-up options live.",
    "onboarding.tour.chat.continue_to_coins": "Go to the coin page",
    "onboarding.tour.coins.packages_title": "Coin packs",
    "onboarding.tour.coins.packages": "When you start running low, you grab a pack here. Small to big — you decide when.",
    "onboarding.tour.coins.starter_credit_title": "Your starter credit: 50 free coins",
    "onboarding.tour.coins.starter_credit": "You have 50 free coins — and here’s the coin shop for when you want more later. Most narrators cost 1–2 coins per message.",
    "onboarding.tour.coins.cheapest_pack_title": "Your first purchase",
    "onboarding.tour.coins.cheapest_pack": "If you enjoy Lorath, we'd love your first purchase — even the smallest pack covers about 100 messages.",
    "onboarding.tour.coins.flat_section_title": "Flat rate instead of single coins",
    "onboarding.tour.coins.flat_section": "A \"message flat\" works like a flat rate: pay once, then write as many messages as you like — daily or monthly. If you play regularly, it saves you money compared to buying individual coins.",
    "onboarding.tour.help.tindra_title": "Tindra is just a tap away",
    "onboarding.tour.help.tindra_fab": "The purple button opens me as a helpbot. Ask me about rules, features or one of your worlds — I have access to your data.",
    "onboarding.tour.help.feedback_title": "Feedback & bug reports",
    "onboarding.tour.help.feedback_fab": "The button opens the feedback modal. Send text + a screenshot — it lands directly with our team.",
    "onboarding.tour.help.contact_title": "Direct contact",
    "onboarding.tour.help.contact_text": "Prefer email? Just write us — we reply personally, usually within 1-2 days.",
    "onboarding.tour.back": "← Back",
    "onboarding.tour.exit_confirm_title": "End the tour?",
    "onboarding.tour.exit_confirm_text": "You can restart it anytime from settings.",
    "onboarding.tour.exit_confirm_yes": "Yes, end it",
    "onboarding.tour.exit_confirm_no": "Keep going",
    "onboarding.tour.closing.title": "Your turn now",
    "onboarding.tour.closing.text": "Just write — Tindra weaves the story with you. There's no right or wrong, try things out. Have fun in Lorath{name_phrase}!",
    "onboarding.tour.closing.cta": "Keep playing",
    "common.unknown_error": "Unknown error",
    "common.error_with_message": "Error: {msg}",
    "legal.agb.title": "General Terms and Conditions",
    "legal.use_terms.title": "Terms of Use",
    "legal.privacy.title": "Privacy Policy",
    "onboarding.tree.login.offline": "I can't reach the server right now. Are you online? Check your connection and try again.",
    "auth.social_opening": "Opening browser …",
    "auth.oauth_denied": "The provider declined sign-in. Please try again.",
    "auth.oauth_in_progress": "A sign-in is already in progress. Please finish it first.",
    "auth.social_login_failed": "Login failed. Please try again.",
    "auth.social_login_timeout": "Login took too long. Are you online? Please try again.",
    "common.section_error": "This section could not be loaded.",
    "common.reload": "Reload",
    "common.error_details": "Details",
    "start.try_cta": "Try it out",
    "auth.unlink_not_linked": "This account is not linked to that provider.",
    "auth.unlink_last_method": "That is your only way to sign in. Set a password first, or link another provider.",
    "auth.unlink_error": "The account could not be disconnected.",
    "onboarding.tree.start.option_create_account": "I would like to create an account right away",
    "onboarding.tree.guest.purpose_intro": "Good to have you here! What brings you to Lorath?",
    "onboarding.tree.guest.purpose_companion": "Get to know a companion",
    "onboarding.tree.guest.purpose_adventure": "Experience an adventure",
    "onboarding.tree.guest.age_intro": "So I can show you suitable content: how old are you?",
    "onboarding.tree.guest.age_under12": "I am under 12",
    "onboarding.tree.guest.age_12to15": "I am 12 to 15",
    "onboarding.tree.guest.age_16plus": "I am 16 or older",
    "onboarding.tree.guest.failed": "That did not work just now: {error}",
    "onboarding.tree.guest.retry": "Try again",
    "onboarding.tree.guest.register_instead": "Create an account instead",
    "onboarding.tree.guest.error_rate_limited": "There are too many attempts right now. Please try again later.",
    "onboarding.tree.guest.error_beta_restricted": "New sign-ups are closed on this test environment. Please sign in with an existing account.",
    "auth.guest_logout.title": "Sign out without an account?",
    "auth.guest_logout.body": "Without an account you lose your characters and coins. They cannot be restored afterwards.",
    "auth.guest_logout.secure_account": "Secure account",
    "auth.guest_logout.logout_anyway": "Sign out anyway",
    "onboarding.tree.guest.terms_hint": "By continuing you accept the terms of use and the privacy policy.",
    "auth.marketing_recap_checkbox": "Receive a weekly recap by email (confirmation by email required)",
    "entry.continue_apple": "Continue with Apple",
    "entry.continue_google": "Continue with Google",
    "entry.register_email": "Register with email",
    "entry.try_guest": "Try it without an account first",
    "entry.have_account": "I have an account",
    "entry.tap_to_start": "Tap to start right away",
    "entry.build_own": "Create your own adventure",
    "entry.secure_title": "Save your account",
    "entry.secure_body": "Save your story so you can find it again on any device.",
    "entry.secure_apple": "Save with Apple",
    "entry.secure_google": "Save with Google",
    "entry.secure_email": "Save with email",
    "entry.later": "Later",
    "entry.expiry_body": "Your guest access expires within the next five days. Save your account to continue your story afterwards.",
    "entry.oauth_already_linked": "This Apple or Google account is already linked to another Lorath account. The accounts will not be merged. Save this story with another login or with email.",
    "entry.secure_error": "We couldn't save your account. You can try again or save your story with email.",
    "entry.walkthrough": "Walkthrough",
    "entry.walkthrough_error": "The walkthrough couldn't be opened. Please try again.",
    "entry.what_do_you_do": "What do you do?"
  }
};
